import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      info: {
        joy_run: true,
        gudong: false,
        jian_bu: false
      }
    };
  },
  mutations: {
    /**
     * 记录绑定状态
     */
    setInfo: function setInfo(state, info) {
      state.info = info;
    }
  },
  actions: {
    /**
     * 获取绑定状态
     */
    getInfo: function getInfo(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/third_plat/info')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setInfo', rdata.data);
              }

              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 发起悦跑圈关联
     */
    joyRunApply: function joyRunApply(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var source = _b.source;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/third_plat/joy_run/apply', {
                source: source
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 验证悦跑圈关联
     */
    joyRunAuth: function joyRunAuth(_a, params) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/third_plat/joy_run/auth', params)];

            case 1:
              response = _b.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 验证悦跑圈关联
     */
    joyRunCancel: function joyRunCancel(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/third_plat/joy_run/cancel')];

            case 1:
              response = _b.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 发起健步圈关联
     */
    jianBuApply: function jianBuApply(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var source = _b.source;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/third_plat/jian_bu/apply', {
                source: source
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 验证健步圈关联
     */
    jianBuAuth: function jianBuAuth(_a, params) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/third_plat/jian_bu/auth', params)];

            case 1:
              response = _b.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 取消健步圈关联
     */
    jianBuCancel: function jianBuCancel(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/third_plat/jian_bu/cancel')];

            case 1:
              response = _b.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 发起咕咚关联
     */
    gudongApply: function gudongApply(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var source = _b.source;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/third_plat/gudong/apply', {
                source: source
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 验证咕咚关联
     */
    gudongAuth: function gudongAuth(_a, params) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/third_plat/gudong/auth', params)];

            case 1:
              response = _b.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 取消咕咚关联
     */
    gudongCancel: function gudongCancel(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/third_plat/gudong/cancel')];

            case 1:
              response = _b.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    }
  }
};
export default m;